import { render, staticRenderFns } from "./DateRestrictionInput.vue?vue&type=template&id=58c534e7"
import script from "./DateRestrictionInput.vue?vue&type=script&lang=js"
export * from "./DateRestrictionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports